<template>
    <v-card>
    <v-form ref="form" v-model="formValid" :lazy-validation="true">
          
        <v-card-title>Edit Transfer Configuration</v-card-title>

        <v-divider />
          
        <v-card-text>
            <span style="display: block;" class="title mt-0 mb-2">Transfer Details</span>
            <v-row dense>
                <v-col cols="6">
                    <v-text-field label="Transfer Name" hint="Type [DATE] to have the transfer date inserted." persistent-hint v-model="$props.configClone.transfer_name" color="#c42111" :rules="[$store.state.validationFuncs.required($props.configClone.transfer_name, 'Transfer Name')]" />
                </v-col>
                <v-col cols="6">
                    <v-text-field readonly disabled filled dense>
                        <template v-slot:label>
                            <span style="color: #dddddd;" v-html="transferNameExample" />
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" lg="12">
                    <v-autocomplete multiple :items="$props.userThresholdList" item-text="thres_name" item-value="thres_id" v-model="$props.configClone.user_thresholds" color="#c42111" label="User Thresholds" />
                </v-col>

                <v-col cols="12" lg="6">
                    <v-select :items="protocolList" v-model="$props.configClone.protocol" @change="protocolChange" color="#c42111" label="Protocol"></v-select>
                </v-col>

                <template v-if="$props.configClone.protocol == 'ftp' || $props.configClone.protocol == 'sftp'">
                    <v-col cols="12" lg="3">
                        <v-text-field label="Username" v-model="$props.configClone.username" color="#c42111" :rules="[validation.required($props.configClone.username)]" />
                    </v-col>
                    <v-col cols="12" lg="3">
                        <v-text-field label="Password" v-model="$props.configClone.password" color="#c42111" :rules="[validation.required($props.configClone.password)]" />
                    </v-col>
                    <v-col cols="12" lg="8">
                        <v-text-field label="Destination Address" v-model="$props.configClone.dest_host" color="#c42111" :rules="[validation.required($props.configClone.dest_host)]" />
                    </v-col>
                    <v-col cols="12" lg="4">
                        <v-text-field label="Port" type="number" v-model="$props.configClone.port" color="#c42111" :rules="[validation.required($props.configClone.port)]" />
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field label="Destination Folder" v-model="$props.configClone.dest_folder" color="#c42111" :rules="[validation.required($props.configClone.dest_folder)]" />
                    </v-col>
                </template>

                <!-- <template v-if="$props.configClone.protocol == 'smtp'">
                    <v-col cols="6">
                        <v-text-field label="Email Address" v-model="$props.configClone.dest_host" color="#c42111" :rules="[validation.email($props.configClone.dest_host)]" />
                    </v-col>
                </template> -->

                <v-col cols="6">
                    <v-select :items="fileFormatList" v-model="$props.configClone.file_format" color="#c42111" label="File Format" @change="fileFormatChange"></v-select>
                </v-col>
                <v-col cols="6">
                    <v-checkbox label="Compress" v-model="$props.configClone.compress" color="#c42111" :disabled="$props.configClone.file_format == 'excel'" />
                </v-col>
                <v-col cols="6">
                    <v-checkbox label="Convert Percentages to Decimal" v-model="$props.configClone.percent_to_decimal" color="#c42111" :disabled="$props.configClone.file_format == 'html'" />
                </v-col>

                <v-col cols="12" v-if="$props.configClone.protocol == 'smtp'">
                    <v-combobox multiple chips autocomplete="off" color="#c42111" v-model="$props.configClone.recipients" :items="users" label="Recipients" hide-selected item-value="user_id" item-text="search" :rules="[$store.state.validationFuncs.requiredList($props.configClone.recipients, 'At least one recipient')]" v-if="!$props.noRecipients">
                        <template v-slot:selection="data">
                            <template v-if="data.item.type == 'user'">
                                <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeRecipient(data.item)" :color="data.item.user_page_email ? validUserRecipientColor : noEmailColor">
                                    <v-avatar left>
                                        <v-img :src="data.item.userImage" v-if="data.item.userImage" />
                                        <v-icon v-else>mdi-account-circle</v-icon>
                                    </v-avatar>
                                    {{ data.item.user_fullname }}
                                </v-chip>
                            </template>
                            <template v-else-if="data.item.type == 'group'">
                                <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeRecipient(data.item)" :color="!data.item.noEmails ? validUserRecipientColor : noEmailColor">
                                    <v-avatar left>
                                        <v-icon>mdi-account-group</v-icon>
                                    </v-avatar>
                                    {{ data.item.group_name }}
                                </v-chip>
                            </template>
                            <template v-else>
                                <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeRecipient(data.item)" :color="(typeof $store.state.validationFuncs.email(data.item) === 'string') ? noEmailColor : validUserRecipientColor">
                                    {{ data.item }}
                                </v-chip>
                            </template>
                        </template>

                        <template v-slot:item="data">
                            <v-list-item-avatar>
                                <v-img :src="data.item.userImage" v-if="data.item.userImage" />
                                <v-icon x-large v-else-if="data.item.type == 'group'">mdi-account-group</v-icon>
                                <v-icon x-large v-else>mdi-account-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ data.item.type == 'user' ? data.item.user_fullname : data.item.group_name }}</v-list-item-title>
                                <v-list-item-subtitle v-if="data.item.type == 'user'">{{ data.item.user_username }} <span :style="{color: noEmailColor}" v-if="!data.item.user_page_email">(no email)</span></v-list-item-subtitle>
                                <v-list-item-subtitle v-if="data.item.type == 'group'" v-html="data.item.subtitle"></v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-combobox>
                </v-col>

            </v-row>

            <span style="display: inline-block;" class="title mt-5 mb-2 mr-2">Transfer Schedule</span>
            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" style="display: inline-block; vertical-align: baseline;" color="#c42111" min-width="30" width="30" height="30" @click="getScheduledTransferDatetimes">
                        <v-icon>mdi-calendar</v-icon>
                    </v-btn>
                </template>
                <span>View next scheduled transfers</span>
            </v-tooltip>

            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-select label="Recurs" v-model="$props.configClone.schedules[0].recur_type" color="#c42111" :items="recurOptions" />
                </v-col>

                <v-col cols="12" sm="6" v-if="$props.configClone.schedules[0].recur_type != 'hourly'">
                    <v-menu v-model="editScheduleTime" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="$props.configClone.schedules[0].recur_time" color="#c42111" label="At This Time" prepend-icon="access_time" readonly v-on="on" :rules="[$store.state.validationFuncs.required($props.configClone.schedules[0].recur_time, 'Time')]"></v-text-field>
                        </template>
                        <v-time-picker v-model="$props.configClone.schedules[0].recur_time" color="#c42111" :hourOnly="false" :format="'24hr'" use-seconds scrollable />
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" v-if="$props.configClone.schedules[0].recur_type == 'hourly'">
                    <v-select v-model="hourlyMinute" label="At this minute" color="#c42111" :items="minuteOptions" />
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="2" class="text-left mt-6">
                    <span>Repeat every: </span>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-select class="text-left" v-model="$props.configClone.schedules[0].repeat_frequency" color="#c42111" :items="recurFrequencyOptions" />
                </v-col>
                <v-col cols="12" sm="2" class="text-left mt-6">
                    {{recurTypeText}}
                </v-col>
                <v-col cols="12" sm="6" v-if="$props.configClone.schedules[0].recur_type == 'weekly' || $props.configClone.schedules[0].recur_type == 'monthly'">
                    <v-select label="Repeat on" v-model="repeatOnWeekdays" color="#c42111" :items="weekDayOptions" multiple v-if="$props.configClone.schedules[0].recur_type == 'weekly'" :rules="[validation.weekdayRequired($props.configClone.schedules[0].recur_type, repeatOnWeekdays)]" />

                    <v-select label="Repeat on" v-model="repeatOnMonthDay" color="#c42111" :items="monthDayOptions" v-if="$props.configClone.schedules[0].recur_type == 'monthly'" :rules="[$store.state.validationFuncs.required(repeatOnMonthDay, 'Day of month')]">
                        <template v-slot:item="{item}">
                            <span v-text="item" />
                            <span class="disclaimer-text" v-text="'(When applicable, else last day of month)'" v-if="item > 28" />
                        </template>
                        <template v-slot:selection="{item}">
                            <span v-text="item" />
                            <span class="disclaimer-text selected" v-text="'(When applicable, else last day of month)'" v-if="item > 28" />
                        </template>
                    </v-select>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="5">
                    <v-menu v-model="editStartDate" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="$props.configClone.schedules[0].start_date" color="#c42111" label="Starts On" prepend-icon="event" readonly v-on="on" :rules="[$store.state.validationFuncs.required($props.configClone.schedules[0].start_date, 'Start Date')]" />
                        </template>
                        <v-date-picker v-model="$props.configClone.schedules[0].start_date" color="#c42111" scrollable />
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-switch color="#c42111" :label="neverEnds ? 'Never Ends' : 'Until'" v-model="neverEnds" />
                </v-col>
                <v-col cols="12" sm="5">
                    <v-menu v-model="editEndDate" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="$props.configClone.schedules[0].end_date" color="#c42111" label="Ends On" prepend-icon="event" readonly v-on="on" :disabled="neverEnds" :rules="[validation.dateOrder($props.configClone.schedules[0].start_date, $props.configClone.schedules[0].end_date, neverEnds)]" />
                        </template>
                        <v-date-picker v-model="$props.configClone.schedules[0].end_date" color="#c42111" scrollable />
                    </v-menu>
                </v-col>
            </v-row>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text @click="saveClick">Save</v-btn>
        </v-card-actions>

    </v-form>

    <v-dialog v-model="showScheduledTransferDatetimes" persistent width="400px" max-width="80%" @keydown="(k) => {k.key == 'Escape' ? showScheduledTransferDatetimes = false : null}" v-if="showScheduledTransferDatetimes">
        <v-card>
            <v-card-title>Next Scheduled Transfer Times</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-4">
                <span style="display: block;" v-for="(datetime, index) in scheduledTransferDatetimes" :key="datetime">
                    {{ datetime }}
                </span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text @click="showScheduledTransferDatetimes = false">Ok</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    </v-card>
</template>

<script>
export default {
    name: 'TransferConfigurationEdit',
    props: ['configClone', 'userThresholdList'],
    components: {
    },
    data: () => ({
        protocolList: [{text: 'FTP', value: 'ftp'}, {text: 'SFTP', value: 'sftp'}, {text: 'SMTP', value: 'smtp'}, {text: 'Web/Samba', value: 'samba'}],
        fileFormatList: ["excel", "csv", "html"],
        formValid: true,


        users: [],
        noEmailColor: '#ff5252',
        validUserRecipientColor: '#4caf50',

        recurOptions: [
            {text: 'Hourly', value: 'hourly'},
            {text: 'Daily', value: 'daily'},
            {text: 'Weekly', value: 'weekly'},
            {text: 'Monthly', value: 'monthly'},
            {text: 'Yearly', value: 'yearly'}
        ],
        weekDayOptions: [
            {text: 'Sunday', value: 'sunday'},
            {text: 'Monday', value: 'monday'},
            {text: 'Tuesday', value: 'tuesday'},
            {text: 'Wednesday', value: 'wednesday'},
            {text: 'Thursday', value: 'thursday'},
            {text: 'Friday', value: 'friday'},
            {text: 'Saturday', value: 'saturday'}
        ],
        recurFrequencyOptions: [],
        monthDayOptions: [],
        minuteOptions: [],
        editScheduleTime: false,
        neverEnds: false,
        editStartDate: false,
        editEndDate: false,
        repeatOnWeekdays: [],
        repeatOnMonthDay: "",
        validation: {
            email: (value) => (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(value) || "Invalid email address"),
            required: (value) => (value ? true : false || "Required field"),
            dateOrder: (start, end, neverEnds) => ((start < end) || (neverEnds) || `End date must be after Start date`),
            weekdayRequired: (recurType, repeatOnWeekdays) => (recurType != 'weekly' || !!repeatOnWeekdays.length || `You must select at least 1 weekday`),
        },
        scheduledTransferDatetimes: [],
        showScheduledTransferDatetimes: false
    }),

    computed: {
        transferNameExample() {
            let text = this.$props.configClone.transfer_name || 'Threshold Reports [DATE]';
            let date = TELSA.moment().format('YYYY-MM-DD')
            return text.replaceAll("[DATE]", `<b>${date}</b>`);
        },

        recurTypeText: function() {
            if(this.$props.configClone.schedules[0].recur_type == 'hourly') {
                return 'hours';
            }
            else if(this.$props.configClone.schedules[0].recur_type == 'daily') {
                return 'days';
            }
            else if(this.$props.configClone.schedules[0].recur_type == 'weekly') {
                return 'weeks';
            }
            else if(this.$props.configClone.schedules[0].recur_type == 'monthly') {
                return 'months';
            }
            else if(this.$props.configClone.schedules[0].recur_type == 'yearly') {
                return 'years';
            }
        },

        repeatOn: function() {
            if(this.$props.configClone.schedules[0].recur_type == 'weekly') {
                return this.repeatOnWeekdays.join();
            }
            else if(this.$props.configClone.schedules[0].recur_type == 'monthly') {
                return this.repeatOnMonthDay;
            }
            return null;
        },

        hourlyMinute: {
            get() {
                return this.$props.configClone.schedules[0].recur_time ? TELSA.moment(this.$props.configClone.schedules[0].recur_time, ['HH:mm:ss']).minute() : 0;
            },
            set(value) {
                let strValue = value < 10 ? `0${value}` : String(value);
                this.$props.configClone.schedules[0].recur_time = `00:${strValue}:00`;
            }
        }
    },

    methods: {
        protocolChange: function(val) {
            if(val == 'ftp') {
                this.$props.configClone.port = 21;
            }
            else if(val == 'sftp') {
                this.$props.configClone.port = 22;
            }
            else if(val == 'smtp') {
                this.clearValues();
                this.$props.configClone.port = 25;
            }
            else if(val == 'samba') {
                this.clearValues();
                this.$props.configClone.port = 445;
            }
        },

        fileFormatChange: function(val) {
            if(val == 'excel') {
                this.$props.configClone.compress = false;
            }
            else if(val == 'csv') {
                
            }
            else if(val == 'html') {
                this.$props.configClone.percent_to_decimal = false;
            }
        },

        clearValues: function() {
            this.$props.configClone.dest_folder = "";
            this.$props.configClone.dest_host = "";
            this.$props.configClone.password = "";
            this.$props.configClone.username = "";
        },

        saveClick: function() {
            if(this.$refs.form.validate()) {
                this.$emit('save', this.$props.configClone);
            }
        },

        setupItems: function() {
            let users = JSON.parse(JSON.stringify(this.$store.state.batchConfig.users));
            users.forEach(u => {
                u.type = 'user';
                u.search = `${u.user_username}${u.user_fullname}`;
            });

            let groups = JSON.parse(JSON.stringify(this.$store.state.batchConfig.groups));
            groups.forEach(g => {
                g.type = 'group';
                g.search = `${g.group_name}`;
                let subtitle = '';
                g.noEmails = true;
                for(let userId of g.group_members) {
                    let user = this.$store.state.batchConfig.users.find(u => u.user_id == userId);
                    if(user.user_page_email) {
                        subtitle += `<span>${user.user_username}</span>, `;
                        g.noEmails = false;
                    }
                    else {
                        subtitle += `<span style="color: ${this.noEmailColor}">${user.user_username}</span>, `;
                    }
                }
                if(subtitle) {
                    subtitle = subtitle.substring(0, subtitle.length - 2);
                }
                g.subtitle = subtitle;
            });
            users = users.concat(groups);

            users.unshift({header: 'Select a user or add an email address'});
            this.users = users;

            if(this.$props.configClone.schedules[0].recur_type == 'weekly') {
                this.repeatOnWeekdays = this.$props.configClone.schedules[0].repeat_on.split(',');
            }
            else if(this.$props.configClone.schedules[0].recur_type == 'monthly') {
                this.repeatOnMonthDay = this.$props.configClone.schedules[0].repeat_on;
            }

            if(!this.$props.configClone.schedules[0].end_date) {
                this.neverEnds = true;
            }

            for(let i = 1; i <= 31; i++) {
                this.recurFrequencyOptions.push(i.toString());
                this.monthDayOptions.push(i.toString());
            }

            for(let i = 0; i <= 59; i++) {
                //this.minuteOptions.push(i.toString());
                this.minuteOptions.push(i);
            }
        },

        removeRecipient: function(recipient) {
            const index = this.$props.configClone.recipients.indexOf(recipient);
            if(index >= 0) {
                this.$props.configClone.recipients.splice(index, 1);
            }
        },

        getScheduledTransferDatetimes: function() {
            if(this.$refs.form.validate()) {
                TELSA.loading(true);
                let route = (TELSA.apiHost + "userthreshold/usertransferdatetimes");
                this.$http.post(route, {args: {transferConfigurationSchedule: this.$props.configClone.schedules[0], quantity: 10}}).then(response => {
                    let results = response.body;
                    this.scheduledTransferDatetimes = results.map(x => TELSA.moment(x).format('dddd MMMM Do YYYY, HH:mm:ss'));
                    this.showScheduledTransferDatetimes = true;
                    TELSA.loading(false);
                });
            }
        },
    },

    watch: {
        repeatOn: {
            handler(newVal, oldVal) {
                this.$props.configClone.schedules[0].repeat_on = this.repeatOn;
            }
        },

        neverEnds(newVal, oldVal) {
            if(newVal != oldVal && newVal == true) {
                this.$props.configClone.schedules[0].end_date = null;
            }
        }
    },

    created() {
        this.setupItems();
    },

    mounted() {
    },

};
</script>

<style scoped>

    .disclaimer-text {
        color: yellow;
        position: absolute;
        left: 50px;
        font-size: 11px;
        font-weight: bold;
    }
    .disclaimer-text.selected {
        left: 30px;
    }

</style>
